export default "__VITE_ASSET__BTNTB_tc__"